export default "/images/botman-icon.png?0d031f65dbb4ef9e2b04f998f8402a4e";